// deps
import React, { ReactElement, useContext, memo, useCallback } from "react";

// internal deps
import { PaymentAlert } from "@swiggy-private/payment-ui";
import { PaymentAlertProps } from "@swiggy-private/payment-types";
import { CheckoutContext, CheckoutActionTypes } from "@swiggy-private/checkout-core";

function GenericPaymentAlert(props: PaymentAlertProps): ReactElement | null {
    const { setCheckoutState } = useContext(CheckoutContext);

    const onOverlayClose = useCallback(() => {
        setCheckoutState({ type: CheckoutActionTypes.SHOW_PAYMENTS });
    }, [setCheckoutState]);

    return (
        <PaymentAlert
            {...props}
            hideOnOverlayClick={props.hideOnOverlayClick ?? true}
            onClose={props.onClose ?? onOverlayClose}
        />
    );
}

export default memo(GenericPaymentAlert);
